import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=f6339194&scoped=true"
import script from "./QuestionDetail.vue?vue&type=script&lang=ts"
export * from "./QuestionDetail.vue?vue&type=script&lang=ts"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=f6339194&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6339194",
  null
  
)

export default component.exports